import { render, staticRenderFns } from "./sorter-icon.vue?vue&type=template&id=2f2a8e24&"
import script from "./sorter-icon.vue?vue&type=script&lang=js&"
export * from "./sorter-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports